var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-dots"},_vm._l((3),function(dotIndex){return _c('div',{key:dotIndex,staticClass:"loading-dots--dot",style:({ backgroundColor: _vm.bgColor })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }